import { createLayoutPortalToken } from '@sketch/utils'

export const header = createLayoutPortalToken('header')
export const sidebarRight = createLayoutPortalToken('sidebar-right')
export const footer = createLayoutPortalToken('footer')
